import React from 'react';
import './product-technologies.scss';

interface ProductTechnologiesProps {
    technologies: { label: string; description: string; }[];
}

const ProductTechnologies: React.FC<ProductTechnologiesProps> = ({ technologies }) => (
    <ul className="technologies">
        {
            technologies.map(technology => (
                <li key={technology.label}>
                    <p>
                        {technology.label}
                    </p>
                    {technology.description}
                </li>
            ))
        }
    </ul>
);

export default ProductTechnologies;
